export function consumeFlag(flag: { current: boolean }): boolean {
  if (!flag.current) return false;
  flag.current = false;
  return true;
}

export type PendingAdditiveToggle = {
  objectId: string;
};

export function shouldDeferAdditiveToggle(
  additive: boolean,
  objectId: string,
  selectedIds: string[],
): boolean {
  return additive && selectedIds.includes(objectId);
}

export function shouldApplyPendingAdditiveToggle(
  pending: PendingAdditiveToggle | null,
  dragCommitted: boolean,
): PendingAdditiveToggle | null {
  if (!pending || dragCommitted) return null;
  return pending;
}

export function shouldKeepTextEdit(
  editingId: string | null | undefined,
  selectedId: string | null | undefined,
  selectedIds: string[] = [],
): boolean {
  if (!editingId) return false;
  if (selectedIds.length > 1) return false;
  return selectedId === editingId || selectedIds.includes(editingId);
}
